module.exports = __webpack_public_path__ + "static/redot5-a345b66f6b2838eb37ce2e756ddee01c.gif";